export default __webpack_public_path__ + "media/images/flags/md-b088abfdc956e27460971327e8046ded.png";